import { Sparkles } from "lucide-react";
import { useT } from "@/i18n";

export function GuideCompleteOverlay({ onClose }) {
  const t = useT();
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center p-4"
      data-testid="guide-complete-overlay"
      style={{ background: "rgba(28,25,23,0.55)" }}
    >
      <div className="relative w-full max-w-md overflow-hidden rounded-3xl border border-border bg-card p-8 text-center shadow-2xl animate-fade-in">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-primary/25 to-transparent" />
        <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/15 text-primary">
          <Sparkles className="h-8 w-8" />
        </div>
        <h2 className="relative mt-5 font-display text-2xl font-semibold text-foreground">
          {t("guide.complete.title")}
        </h2>
        <p className="relative mt-3 text-sm leading-relaxed text-muted-foreground">
          {t("guide.complete.body")}
        </p>
        <button
          onClick={onClose}
          data-testid="guide-complete-cta"
          className="relative mt-6 inline-flex items-center justify-center rounded-full bg-primary px-6 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          {t("guide.complete.cta")}
        </button>
      </div>
    </div>
  );
}
